module.exports = __webpack_public_path__ + "img/profile-wallet-active.35990ae7.svg";